module.exports = __webpack_public_path__ + "static/other/uniform_design.5d735fe4.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/maps/uniform_design.json
// module id = 2539
// module chunks = 0